import { render, staticRenderFns } from "./LocalisationArticles.vue?vue&type=template&id=902a0236&"
import script from "./LocalisationArticles.vue?vue&type=script&lang=ts&"
export * from "./LocalisationArticles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports